import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Checkbox,
  FormGroup,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import bgImage from "./assets/bg.jpg";
import newbgImage from "./assets/new.jpg";
import { useSearchParams } from "react-router-dom";
import { SubmitFeedbackForm } from "./lib/feedback-api";


export default function FeedbackForm() {
  const [formData, setFormData] = useState({
    overallExperience: "",
    contentRelevance: "",
    usefulTopics: [],
    otherTopic: "",
    facilitatorRating: "",
    sessionEngagement: "",
    keyTakeaways: ["", "", ""],
    suggestions: "",
    additionalTopics: "",
    role: "",
    company: "",
    email:""
  });
  const [searchParams] = useSearchParams();



  useEffect(() => {
    const emailFromURL = searchParams.get('email');
    if (emailFromURL) {
      setFormData((prevData) => ({
        ...prevData,  
        email: emailFromURL, 
      }));
    }
  }, [searchParams]);



  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    let updatedTopics = formData.usefulTopics;
    if (checked) {
      updatedTopics.push(name);
    } else {
      updatedTopics = updatedTopics.filter((topic) => topic !== name);
    }
    setFormData({ ...formData, usefulTopics: updatedTopics });
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTakeawayChange = (index, value) => {
    const updatedTakeaways = [...formData.keyTakeaways];
    updatedTakeaways[index] = value;
    setFormData({ ...formData, keyTakeaways: updatedTakeaways });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.overallExperience || !formData.contentRelevance || !formData.facilitatorRating) {
      alert("Please fill out all required fields.");
      return;
    }

    try {
      const response = await SubmitFeedbackForm(formData);
      if(response.data.status === 'success'){
        alert(`The Feedback Form Submitted Successfully !!`);
        window.open('https://www.masterclasswithsap.com/');
      }else if(response.data.status === 'Exist'){
        alert(`This Email is Already Exist !!!`);
        setFormData({
          overallExperience: "",
          contentRelevance: "",
          usefulTopics: [''],
          otherTopic: "",
          facilitatorRating: "",
          sessionEngagement: "",
          keyTakeaways: ["", "", ""],
          suggestions: "",
          additionalTopics: "",
          role: "",
          company: "",
          email:""
        })
      }
    } catch (err) {
      alert(`Error submitting feedback: ${err.message}`);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
          
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: 850 }, // full width on small screens
          margin: "auto",
          padding: { xs: 2, sm: 4 }, // Smaller padding on mobile
         
          backgroundImage: `url(${newbgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Overlay for readability
        }}
          >
        
        <Paper elevation={3} sx={{ padding: 3  }}>
          <Typography
  variant="h4"
  sx={{
    textAlign: "center", // Center-aligns the title
    fontWeight: "bold", // Makes the text bold
    fontFamily: "Roboto, sans-serif", // Ensures the Roboto font is used
    padding: "20px 0", // Adds vertical padding
    color: "black", // Sets a custom color for the text
    textTransform: "uppercase", // Makes the text uppercase
    borderBottom: "2px solid black", // Adds an underline
  }}
  gutterBottom
>
  Feedback Form
</Typography>
          <Typography variant="h5"  gutterBottom>
            RISE with SAP Project Management Masterclass Feedback Form
          </Typography>
          <Typography variant="body1" gutterBottom>
            Thank you for attending the RISE with SAP Project Management Masterclass! Your feedback is invaluable to us. Please take a few minutes to share your thoughts.
          </Typography>
          <form onSubmit={handleSubmit}>
            {/* 1. Overall Experience */}
            <Box marginY={2}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: "bold", color: "black" }}>1. Overall Experience</FormLabel>
                <RadioGroup
                  name="overallExperience"
                  value={formData.overallExperience}
                  onChange={handleRadioChange}
                >
                  <FormLabel sx={{ color: "black" }}>• How would you rate your overall experience? </FormLabel>
                  <FormControlLabel value="Excellent" control={<Radio />} label="Excellent" />
                  <FormControlLabel value="Good" control={<Radio />} label="Good" />
                  <FormControlLabel value="Average" control={<Radio />} label="Average" />
                  <FormControlLabel value="Poor" control={<Radio />} label="Poor" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

            {/* 2. Content Relevance */}
            <Box marginY={2}>
              <FormControl fullWidth>
                <FormLabel sx={{ fontWeight: "bold", color: "black" }}>2. Content Relevance</FormLabel>
                <RadioGroup
                  name="contentRelevance"
                  value={formData.contentRelevance}
                  onChange={handleRadioChange}
                >
                  <FormLabel sx={{ color: "black" }}>• Was the content relevant to your role and expectations?</FormLabel>
                  <FormControlLabel value="Highly Relevant" control={<Radio />} label="Highly Relevant" />
                  <FormControlLabel value="Somewhat Relevant" control={<Radio />} label="Somewhat Relevant" />
                  <FormControlLabel value="Neutral" control={<Radio />} label="Neutral" />
                  <FormControlLabel value="Not Relevant" control={<Radio />} label="Not Relevant" />
                </RadioGroup>
              </FormControl>
              <FormGroup>
                <FormLabel sx={{ color: "black" }}>• Which topics were the most useful? (Select all that apply)</FormLabel>
                <FormControlLabel
                  control={<Checkbox />}
                  label="SAP Implementation Methodology"
                  name="SAP Implementation Methodology"
                  onChange={handleCheckboxChange}
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Project Planning & Governance"
                  name="Project Planning & Governance"
                  onChange={handleCheckboxChange}
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Change Management"
                  name="Change Management"
                  onChange={handleCheckboxChange}
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Risk Mitigation"
                  name="Risk Mitigation"
                  onChange={handleCheckboxChange}
                />
                <TextField
                  name="otherTopic"
                  label="Other (please specify)"
                  fullWidth
                  margin="normal"
                  value={formData.otherTopic}
                  onChange={handleTextChange}
                />
              </FormGroup>
            </Box>
            <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

          {/* 3. Delivery & Facilitation */}
          <Box marginY={2}>
            <FormControl>
              <FormLabel sx={{ fontWeight: "bold", color: "black", marginBottom: 1 }}>
                3. Delivery & Facilitation
              </FormLabel>
              <RadioGroup
                name="facilitatorRating"
                value={formData.facilitatorRating}
                onChange={handleRadioChange}
              >
                <FormLabel sx={{ color: "black" }}>
                  • How would you rate the facilitator's knowledge and delivery?
                </FormLabel>
                <FormControlLabel value="Excellent" control={<Radio />} label="Excellent" />
                <FormControlLabel value="Good" control={<Radio />} label="Good" />
                <FormControlLabel value="Average" control={<Radio />} label="Average" />
                <FormControlLabel value="Poor" control={<Radio />} label="Poor" />
              </RadioGroup>
            </FormControl>
            <FormGroup>
              <FormControl>
                <FormLabel sx={{ color: "black" }}>
                  • Was the session interactive and engaging?
                </FormLabel>
                <RadioGroup
                  name="sessionEngagement"
                  value={formData.sessionEngagement}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="Somewhat" control={<Radio />} label="Somewhat" />
                  <FormControlLabel value="No" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </FormGroup>
          </Box>

          <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

          {/* 4. Key Takeaways */}
          <Box marginY={2}>
            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>4. Key Takeaways </FormLabel>
            <Typography variant="body2" gutterBottom>
              What are your top three takeaways from the session?
            </Typography>
            {formData.keyTakeaways.map((takeaway, index) => (
              <TextField
                key={index}
                fullWidth
                margin="normal"
                placeholder={`Takeaway ${index + 1}`}
                value={takeaway}
                onChange={(e) => handleTakeawayChange(index, e.target.value)}
              />
            ))}
          </Box>
          <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

          {/* 5. Suggestions */}
          <Box marginY={2}>
            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>5. Suggestions for Improvement</FormLabel>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="suggestions"
              value={formData.suggestions}
              onChange={handleTextChange}
            />
          </Box>
          <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

          {/* 6. Additional Topics */}
          <Box marginY={2}>
            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>
              6. Additional Topics to Cover
            </FormLabel>
            <TextField
              fullWidth
              margin="normal"
              name="additionalTopics"
              value={formData.additionalTopics}
              onChange={handleTextChange}
            />
          </Box>
          <Divider sx={{ borderBottomWidth: 2, marginY: 2 }} />

          {/* 7. Participant Information */}
          <Box marginY={2}>
            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>7. Participant Information</FormLabel>
            <TextField
              fullWidth
              label="Your Role"
              margin="normal"
              name="role"
              value={formData.role}
              onChange={handleTextChange}
            />
            <TextField
              fullWidth
              label="Your Company"
              margin="normal"
              name="company"
              value={formData.company}
              onChange={handleTextChange}
            />
          </Box>

          <Button
  type="submit"
  variant="contained"
  color="primary"
  sx={{
    width: { xs: "100%", sm: "auto" }, // Full width on small screens, auto on larger
    padding: "10px 20px", // Adjust padding for a balanced look
    fontSize: "1rem", // Slightly smaller font size
    borderRadius: "8px", // Add rounded corners
    textTransform: "none", // Keep text as it is (no uppercase)
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Add a subtle shadow
    margin: "20px auto", // Add margin for spacing and center alignment
    display: "block", // Centers the button horizontally
  }}
>
  Submit Feedback
</Button>
        </form>
      </Paper>
            </Box>
                </Box>
  );
}